import type { MarkerClusterIcons, MarkerImages } from '@/types/map/marker/marker-types.ts';

export const markerIcons: MarkerImages = {
   openAQ: 'images/map-marker-svgs/source-markers/openAQ.png',
   openAQ_inactive: 'images/map-marker-svgs/source-markers/default-inactive.png',
   openAQ_inactive_selected: 'images/map-marker-svgs/source-markers/default-inactive-selected.png',
   openAQ_selected: 'images/map-marker-svgs/source-markers/openAQ-selected.png',
   air: 'images/map-marker-svgs/source-markers/airNow.png',
   air_selected: 'images/map-marker-svgs/source-markers/airNow-selected.png',
   airNowPM10: 'images/map-marker-svgs/source-markers/airNowPM10.png',
   airNowPM25: 'images/map-marker-svgs/source-markers/airNowPM25.png',
   airNowOZONE: 'images/map-marker-svgs/source-markers/airNowOZONE.png',
   airNowPM10_selected: 'images/map-marker-svgs/source-markers/airNowPM10-selected.png',
   airNowPM25_selected: 'images/map-marker-svgs/source-markers/airNowPM25-selected.png',
   airNowOZONE_selected: 'images/map-marker-svgs/source-markers/airNowOZONE-selected.png',
   nmedDrinkingWater: 'images/map-marker-svgs/source-markers/nmedDrinkingWater.png',
   nmedDrinkingWater_inactive: 'images/map-marker-svgs/source-markers/default-inactive.png',
   nmedDrinkingWater_inactive_selected: 'images/map-marker-svgs/source-markers/default-inactive-selected.png',
   nmedDrinkingWater_selected: 'images/map-marker-svgs/source-markers/nmedDrinkingWater-selected.png',
   nmedSurfaceWater: 'images/map-marker-svgs/source-markers/nmedSurfaceWater.png',
   nmedSurfaceWater_selected: 'images/map-marker-svgs/source-markers/nmedSurfaceWater-selected.png',
   nmedPfasGroundWater: 'images/map-marker-svgs/source-markers/nmedPfasGroundWater.png',
   nmedPfasGroundWater_selected: 'images/map-marker-svgs/source-markers/nmedPfasGroundWater-selected.png',
   nmedPfasGroundWater_inactive: 'images/map-marker-svgs/source-markers/nmedPfasGroundWater-inactive.png',
   nmedPfasGroundWater_inactive_selected: 'images/map-marker-svgs/source-markers/nmedPfasGroundWater-inactive-selected.png',
   nmedPfasSurfaceWater: 'images/map-marker-svgs/source-markers/nmedPfasSurfaceWater.png',
   nmedPfasSurfaceWater_selected: 'images/map-marker-svgs/source-markers/nmedPfasSurfaceWater-selected.png',
   nmedPfasSurfaceWater_inactive: 'images/map-marker-svgs/source-markers/nmedPfasSurfaceWater-inactive.png',
   nmedPfasSurfaceWater_inactive_selected: 'images/map-marker-svgs/source-markers/nmedPfasSurfaceWater-inactive-selected.png',
   facilities: 'images/map-marker-svgs/source-markers/facilities.png',
   facilities_inactive: 'images/map-marker-svgs/source-markers/default-inactive.png',
   facilities_inactive_selected: 'images/map-marker-svgs/source-markers/default-inactive-selected.png',
   facilities_selected: 'images/map-marker-svgs/source-markers/facilities-selected.png',
   nasaEvents: 'images/map-marker-svgs/source-markers/nasaEvents.png',
   nasaEvents_selected: 'images/map-marker-svgs/source-markers/nasaEvents-selected.png',
   measurements: 'images/map-marker-svgs/source-markers/measurements.png',
   measurements_selected: 'images/map-marker-svgs/source-markers/measurements-selected.png',
   permit: 'images/map-marker-svgs/permit.png',
   permit_selected: 'images/map-marker-svgs/permit-selected.png',
   ccrReport: 'images/map-marker-svgs/source-markers/ccrReport.png',
   ccrReport_selected: 'images/map-marker-svgs/source-markers/ccrReport-selected.png',
   superfundSites: 'images/map-marker-svgs/source-markers/superfundSites.png',
   superfundSites_inactive: 'images/map-marker-svgs/source-markers/default-inactive.png',
   superfundSites_inactive_selected: 'images/map-marker-svgs/source-markers/default-inactive-selected.png',
   superfundSites_selected: 'images/map-marker-svgs/source-markers/superfundSites-selected.png',
   DEFAULT: 'images/map-marker-svgs/default.png',
   DEFAULT_selected: 'images/map-marker-svgs/default-selected.png',
};

export const markerClusterIcons: Partial<MarkerClusterIcons> = {
   facilities: 'images/map-marker-svgs/marker-cluster-icon-svgs/abqFacilities.svg',
   nmedSurfaceWater: 'images/map-marker-svgs/marker-cluster-icon-svgs/nmedSurfaceWater.svg',
   nmedDrinkingWater: 'images/map-marker-svgs/marker-cluster-icon-svgs/nmedSurfaceWater.svg',
   nmedPfasGroundWater: 'images/map-marker-svgs/marker-cluster-icon-svgs/nmedSurfaceWater.svg',
   nmedPfasSurfaceWater: 'images/map-marker-svgs/marker-cluster-icon-svgs/nmedSurfaceWater.svg',
   air: 'images/map-marker-svgs/marker-cluster-icon-svgs/air.svg',
   airNowPM10: 'images/map-marker-svgs/marker-cluster-icon-svgs/airNowPM10.svg',
   airNowPM25: 'images/map-marker-svgs/marker-cluster-icon-svgs/airNowPM25.svg',
   airNowOZONE: 'images/map-marker-svgs/marker-cluster-icon-svgs/airNowOZONE.svg',
   openAQ: 'images/map-marker-svgs/marker-cluster-icon-svgs/air.svg',
   nasaEvents: 'images/map-marker-svgs/marker-cluster-icon-svgs/drought.svg',
   measurements: 'images/map-marker-svgs/measurements-selected.svg',
   DEFAULT: 'images/map-marker-svgs/marker-cluster-icon-svgs/abqFacilities.svg',
};
